import { useCallback, useEffect, useMemo, useState } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import { isEmpty } from 'lodash'
import { usePrevNextButtons } from './hooks/usePrevNextButtons'
import ClassNames from 'embla-carousel-class-names'

export default function useOurCultureGallery({ data }) {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [ClassNames()])
  const [indexOnFocus, setIndexOnFocus] = useState(1)

  const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } =
    usePrevNextButtons(emblaApi)

  const slides = useMemo(() => {
    if (isEmpty(data?.slides)) return []

    if (data?.slides?.length < 6) return [...data.slides, ...data.slides]

    return data?.slides
  }, [])

  const logSlidesInView = useCallback((emblaApi) => {
    const selected = emblaApi.selectedScrollSnap()

    setIndexOnFocus(selected)
  }, [])

  useEffect(() => {
    if (emblaApi) {
      emblaApi.on('slidesInView', logSlidesInView).on('scroll', logSlidesInView)
    }
  }, [emblaApi, logSlidesInView])

  const imageContent = useMemo(() => {
    if (isEmpty(slides)) return {}

    const content = slides[indexOnFocus]
    if (isEmpty(content)) return {}

    return content?.slide
  }, [indexOnFocus, slides])

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
    imageContent,
    emblaRef,
    slides,
    indexOnFocus,
  }
}
